import React, { createContext, useContext } from "react";
export interface StringContextType {
    timestamp: string;
    setTimestamp: React.Dispatch<React.SetStateAction<string>>;
  }
const TimestampContext: React.Context<StringContextType| null> = createContext<StringContextType| null>(null);

export default TimestampContext;

export const useTimestampContext = (): StringContextType => {
    const context = useContext(TimestampContext);
    if (context === null) {
        throw new Error("useTimestampContext must be used within a TimestampProvider");
    }
    return context;
}